import { createPortal } from 'react-dom'
import { useI18n } from '../i18n'
import { Z_SECURITY } from '../utils/zLayers'
import { Shield } from 'lucide-react'
import orellaLogoWhite from '../assets/orella_logo_white.webp'

/**
 * v187.0: HIPAA privacy screen overlay.
 * 
 * Covers all PHI with branded splash screen when tab is hidden.
 * Uses createPortal to escape scroll-wrapper DOM hierarchy.
 * Matches patient app splash: blue (#46A8F9) background + white wordmark.
 * 
 * v187.0.1: "Continue" is now a proper CTA button with breathe-navy animation.
 */
export default function PrivacyScreen({ requiresReauth, onLogin, onDismiss }) {
  const { t } = useI18n()
  return createPortal(
    <div 
      className="fixed inset-0 flex flex-col items-center justify-center"
      style={{ 
        backgroundColor: '#46A8F9',
        zIndex: Z_SECURITY,
        touchAction: 'none',
      }}
    >
      {/* Logo — centered like splash screen */}
      <img 
        src={orellaLogoWhite} 
        alt="Orella" 
        className="h-12 object-contain"
        style={{ marginBottom: requiresReauth ? '40px' : '60px' }}
      />
      
      {requiresReauth ? (
        <div className="flex flex-col items-center gap-4 px-8">
          {/* Security message */}
          <div className="flex items-center gap-2 mb-2">
            <Shield size={18} color="rgba(255,255,255,0.8)" />
            <p className="text-white/80 text-sm font-medium">
              {t('security.sessionLocked', 'Session locked for your security')}
            </p>
          </div>

          {/* Re-login button */}
          <button
            onClick={onLogin}
            className="px-10 py-3.5 bg-white rounded-full text-base font-semibold transition-all active:scale-[0.97] breathe-navy"
            style={{ color: '#15354F' }}
          >
            {t('auth.signIn')}
          </button>
        </div>
      ) : (
        /* Short absence — CTA button to dismiss */
        <button
          onClick={onDismiss}
          className="px-10 py-3.5 rounded-full text-[15px] font-semibold transition-all active:scale-[0.97] breathe-navy"
          style={{ backgroundColor: '#15354F', color: '#ffffff' }}
        >
          {t('common.continue')}
        </button>
      )}
    </div>,
    document.body
  )
}
